function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1944(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20.44,
    height: 8.69,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.6684615384615384
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 4.345
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.69,
    width: 20.44,
    height: 25.5,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9200000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 21.439999999999998
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34.19,
    width: 20.44,
    height: 26.74,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4066666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 47.559999999999995
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.93,
    width: 20.44,
    height: 27.1,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9200000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 74.48
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88.03,
    width: 20.44,
    height: 28.86,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.044
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 102.46000000000001
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 116.89,
    width: 20.44,
    height: 32.65,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 133.215
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 149.54,
    width: 20.44,
    height: 34.63,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.8133333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 166.855
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 184.17,
    width: 20.44,
    height: 34.85,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 201.595
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 219.01,
    width: 20.44,
    height: 34.99,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 236.505
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 254.01,
    width: 20.44,
    height: 35.72,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9200000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 271.87
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 289.73,
    width: 20.44,
    height: 37.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4066666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 308.285
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 326.84,
    width: 20.44,
    height: 37.18,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.088
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 345.42999999999995
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 364.03,
    width: 20.44,
    height: 38.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 383.16999999999996
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 402.31,
    width: 20.44,
    height: 40.25,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 422.435
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 442.56,
    width: 20.44,
    height: 40.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 462.94
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 483.32,
    width: 20.44,
    height: 41.71,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4066666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 504.175
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 525.04,
    width: 20.44,
    height: 42.37,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 546.2249999999999
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 567.41,
    width: 20.44,
    height: 44.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9200000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 589.435
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 611.46,
    width: 20.44,
    height: 44.05,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4066666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 633.485
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 655.51,
    width: 20.44,
    height: 44.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9200000000000004
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.22,
    y: 677.755
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 0,
    width: 27.81,
    height: 33.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.561999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.345,
    y: 16.62
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48.25,
    y: 0,
    width: 28.17,
    height: 33.24,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.695
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 62.335,
    y: 16.62
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.42,
    y: 0,
    width: 28.39,
    height: 33.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7316666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 90.61500000000001,
    y: 16.62
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.81,
    y: 0,
    width: 29.02,
    height: 33.24,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.836666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 119.32000000000001,
    y: 16.62
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.84,
    y: 0,
    width: 29.07,
    height: 33.24,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.152857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 148.375,
    y: 16.62
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.9,
    y: 0,
    width: 29.83,
    height: 33.24,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.72875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 177.815,
    y: 16.62
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192.73,
    y: 0,
    width: 29.88,
    height: 33.24,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9799999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 207.67,
    y: 16.62
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.61,
    y: 0,
    width: 30.01,
    height: 33.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.287142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.615,
    y: 16.62
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.62,
    y: 0,
    width: 30.1,
    height: 33.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0100000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.67,
    y: 16.62
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.72,
    y: 0,
    width: 30.33,
    height: 33.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.332857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.88500000000005,
    y: 16.62
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.05,
    y: 0,
    width: 32.57,
    height: 33.24,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.652857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 329.33500000000004,
    y: 16.62
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.62,
    y: 0,
    width: 33.34,
    height: 33.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.648000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 362.29,
    y: 16.62
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 378.96,
    y: 0,
    width: 34.37,
    height: 33.24,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 396.145,
    y: 16.62
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.32,
    y: 0,
    width: 34.73,
    height: 33.24,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.748571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430.685,
    y: 16.62
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.05,
    y: 0,
    width: 34.82,
    height: 33.24,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 465.46000000000004,
    y: 16.62
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.87,
    y: 0,
    width: 34.95,
    height: 33.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.648000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 500.345,
    y: 16.62
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 517.82,
    y: 0,
    width: 35.54,
    height: 33.24,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.748571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.59,
    y: 16.62
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 553.36,
    y: 0,
    width: 35.85,
    height: 33.24,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6933333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 571.285,
    y: 16.62
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.21,
    y: 0,
    width: 35.9,
    height: 33.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.748571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.1600000000001,
    y: 16.62
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 625.11,
    y: 0,
    width: 36.44,
    height: 33.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.54
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.33,
    y: 16.62
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 661.54,
    y: 0,
    width: 38.46,
    height: 33.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 680.77,
    y: 16.62
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 33.24,
    width: 37.59,
    height: 34.05,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.405
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 50.265
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 67.28,
    width: 37.59,
    height: 34.12,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.824
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 84.34
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 101.41,
    width: 37.59,
    height: 34.28,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.713333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 118.55
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 135.69,
    width: 37.59,
    height: 34.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.746666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 152.93
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 170.17,
    width: 37.59,
    height: 34.52,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.904000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 187.42999999999998
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 204.7,
    width: 37.59,
    height: 34.72,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.944
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 222.06
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 239.42,
    width: 37.59,
    height: 34.76,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.69
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 256.8
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 274.18,
    width: 37.59,
    height: 34.84,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.8066666666666675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 291.6
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 309.02,
    width: 37.59,
    height: 34.96,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.994285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 326.5
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 343.98,
    width: 37.59,
    height: 37.02,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.404000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 362.49
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 381,
    width: 37.59,
    height: 37.62,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.69875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 399.81
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 418.62,
    width: 37.59,
    height: 38.61,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.265000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 437.925
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 457.23,
    width: 37.59,
    height: 39.01,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.69875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 476.735
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 496.25,
    width: 37.59,
    height: 39.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.518000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 515.775
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 535.3,
    width: 37.59,
    height: 40.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.69875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 555.7199999999999
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 576.13,
    width: 37.59,
    height: 41.08,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.176666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 596.67
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 617.21,
    width: 37.59,
    height: 41.39,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.69875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 637.9050000000001
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.44,
    y: 658.61,
    width: 37.59,
    height: 41.39,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.265000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 39.235,
    y: 679.3050000000001
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 33.24,
    width: 37.39,
    height: 42.22,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.478
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 76.725,
    y: 54.35
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 95.42,
    y: 33.24,
    width: 37.57,
    height: 42.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.514
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.205,
    y: 54.35
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.99,
    y: 33.24,
    width: 38.63,
    height: 42.22,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.518571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.305,
    y: 54.35
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.61,
    y: 33.24,
    width: 38.73,
    height: 42.22,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8729999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 190.97500000000002,
    y: 54.35
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.34,
    y: 33.24,
    width: 39.09,
    height: 42.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.515000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.885,
    y: 54.35
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.43,
    y: 33.24,
    width: 39.19,
    height: 42.22,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.598571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.025,
    y: 54.35
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.62,
    y: 33.24,
    width: 39.19,
    height: 42.22,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.598571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 308.21500000000003,
    y: 54.35
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 327.81,
    y: 33.24,
    width: 39.33,
    height: 42.22,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.8325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 347.475,
    y: 54.35
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.15,
    y: 33.24,
    width: 39.65,
    height: 42.22,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 386.97499999999997,
    y: 54.35
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.8,
    y: 33.24,
    width: 40.04,
    height: 42.22,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.673333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 426.82,
    y: 54.35
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446.84,
    y: 33.24,
    width: 40.85,
    height: 42.22,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.265,
    y: 54.35
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.7,
    y: 33.24,
    width: 40.96,
    height: 42.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.192
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 508.18,
    y: 54.35
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528.66,
    y: 33.24,
    width: 41,
    height: 42.22,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.16,
    y: 54.35
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.65,
    y: 33.24,
    width: 43.19,
    height: 42.22,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.036666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 591.245,
    y: 54.35
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 612.84,
    y: 33.24,
    width: 43.51,
    height: 42.22,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.443999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.595,
    y: 54.35
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 656.35,
    y: 33.24,
    width: 43.65,
    height: 42.22,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.036666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 678.1750000000001,
    y: 54.35
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 75.46,
    width: 45.31,
    height: 40.77,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.09625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 95.845
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 116.22,
    width: 45.31,
    height: 41.69,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.21125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 137.065
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 157.91,
    width: 45.31,
    height: 42.25,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.035714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 179.035
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 200.16,
    width: 45.31,
    height: 43.3,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.66
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 221.81
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 243.46,
    width: 45.31,
    height: 43.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.822222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 265.16
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 286.87,
    width: 45.31,
    height: 44.29,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.0725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 309.015
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 331.16,
    width: 45.31,
    height: 44.79,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.1975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 353.555
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 375.95,
    width: 45.31,
    height: 44.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.4071428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 398.375
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 420.8,
    width: 45.31,
    height: 45.15,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.64375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 443.375
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 465.95,
    width: 45.31,
    height: 45.94,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.551666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 488.91999999999996
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 511.89,
    width: 45.31,
    height: 46.63,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.062000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 535.205
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 558.52,
    width: 45.31,
    height: 46.67,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.062000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 581.855
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 605.19,
    width: 45.31,
    height: 47.19,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.062000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 628.7850000000001
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.03,
    y: 652.38,
    width: 45.31,
    height: 47.62,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.531000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.685,
    y: 676.1899999999999
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 75.46,
    width: 45.92,
    height: 48.85,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5600000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 126.30000000000001,
    y: 99.88499999999999
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.26,
    y: 75.46,
    width: 47.14,
    height: 48.85,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8566666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 172.82999999999998,
    y: 99.88499999999999
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 196.4,
    y: 75.46,
    width: 47.99,
    height: 48.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.998333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 220.395,
    y: 99.88499999999999
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.39,
    y: 75.46,
    width: 48.15,
    height: 48.85,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.878571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 268.465,
    y: 99.88499999999999
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292.54,
    y: 75.46,
    width: 49.31,
    height: 48.85,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 317.19500000000005,
    y: 99.88499999999999
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.85,
    y: 75.46,
    width: 49.34,
    height: 48.85,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.978571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.52000000000004,
    y: 99.88499999999999
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 391.19,
    y: 75.46,
    width: 50.75,
    height: 48.85,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.141666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 416.565,
    y: 99.88499999999999
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441.93,
    y: 75.46,
    width: 51.17,
    height: 48.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 467.515,
    y: 99.88499999999999
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493.11,
    y: 75.46,
    width: 51.27,
    height: 48.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.141666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.745,
    y: 99.88499999999999
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.37,
    y: 75.46,
    width: 51.6,
    height: 48.85,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.978571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 570.17,
    y: 99.88499999999999
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 595.97,
    y: 75.46,
    width: 51.91,
    height: 48.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.978571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 621.9250000000001,
    y: 99.88499999999999
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 647.88,
    y: 75.46,
    width: 52.12,
    height: 48.85,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.978571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.9399999999999,
    y: 99.88499999999999
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 124.31,
    width: 51.56,
    height: 49.38,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.1725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 149
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 173.68,
    width: 51.56,
    height: 49.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.18625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 198.425
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 223.18,
    width: 51.56,
    height: 50.45,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 248.405
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 273.62,
    width: 51.56,
    height: 50.51,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.418333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 298.875
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 324.13,
    width: 51.56,
    height: 51.26,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.543333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 349.76
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 375.39,
    width: 51.56,
    height: 52.45,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.312000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 401.615
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 427.83,
    width: 51.56,
    height: 53,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.312000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 454.33
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 480.83,
    width: 51.56,
    height: 53.52,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.365714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 507.59
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 534.35,
    width: 51.56,
    height: 54.56,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.312000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 561.63
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 588.91,
    width: 51.56,
    height: 55.02,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.365714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 616.42
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 103.34,
    y: 643.93,
    width: 51.56,
    height: 56.07,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.593333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 129.12,
    y: 671.9649999999999
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.91,
    y: 124.31,
    width: 52.23,
    height: 55.84,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.461428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 181.025,
    y: 152.23000000000002
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 207.14,
    y: 124.31,
    width: 52.82,
    height: 55.84,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.545714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.54999999999998,
    y: 152.23000000000002
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 259.95,
    y: 124.31,
    width: 53.24,
    height: 55.84,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.873333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 286.57,
    y: 152.23000000000002
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 313.2,
    y: 124.31,
    width: 54.18,
    height: 55.84,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.28999999999996,
    y: 152.23000000000002
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 367.38,
    y: 124.31,
    width: 54.71,
    height: 55.84,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.118333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 394.735,
    y: 152.23000000000002
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 422.09,
    y: 124.31,
    width: 54.77,
    height: 55.84,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.954
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.47499999999997,
    y: 152.23000000000002
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.86,
    y: 124.31,
    width: 55.14,
    height: 55.84,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 504.43,
    y: 152.23000000000002
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 532,
    y: 124.31,
    width: 55.46,
    height: 55.84,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.922857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 559.73,
    y: 152.23000000000002
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 587.47,
    y: 124.31,
    width: 55.49,
    height: 55.84,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.248333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 615.215,
    y: 152.23000000000002
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.96,
    y: 124.31,
    width: 57.04,
    height: 55.84,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.48,
    y: 152.23000000000002
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.91,
    y: 180.15,
    width: 58.97,
    height: 54.32,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.053333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.39499999999998,
    y: 207.31
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.91,
    y: 234.46,
    width: 58.97,
    height: 54.67,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.83375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.39499999999998,
    y: 261.795
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.91,
    y: 289.14,
    width: 58.97,
    height: 55.58,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9399999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.39499999999998,
    y: 316.93
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.91,
    y: 344.72,
    width: 58.97,
    height: 56.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.361666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.39499999999998,
    y: 372.805
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.91,
    y: 400.89,
    width: 58.97,
    height: 58.37,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.728333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.39499999999998,
    y: 430.075
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.91,
    y: 459.26,
    width: 58.97,
    height: 59.41,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.552222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.39499999999998,
    y: 488.965
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.91,
    y: 518.66,
    width: 58.97,
    height: 60.17,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.897
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.39499999999998,
    y: 548.745
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.91,
    y: 578.83,
    width: 58.97,
    height: 60.27,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.794
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.39499999999998,
    y: 608.965
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 154.91,
    y: 639.1,
    width: 58.97,
    height: 60.9,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.37125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.39499999999998,
    y: 669.5500000000001
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.88,
    y: 180.15,
    width: 55.04,
    height: 65.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.4,
    y: 212.8
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 268.92,
    y: 180.15,
    width: 55.36,
    height: 65.3,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.226666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.6,
    y: 212.8
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.29,
    y: 180.15,
    width: 57.01,
    height: 65.3,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.144285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.795,
    y: 212.8
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.29,
    y: 180.15,
    width: 59.57,
    height: 65.3,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.914
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 411.07500000000005,
    y: 212.8
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.86,
    y: 180.15,
    width: 63.27,
    height: 65.3,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.8175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 472.495,
    y: 212.8
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.14,
    y: 180.15,
    width: 63.55,
    height: 65.3,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.591666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 535.915,
    y: 212.8
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.69,
    y: 180.15,
    width: 63.62,
    height: 65.3,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.068888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 599.5,
    y: 212.8
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.31,
    y: 180.15,
    width: 68.69,
    height: 65.3,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.1625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.655,
    y: 212.8
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.88,
    y: 245.45,
    width: 75.38,
    height: 59.88,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.57,
    y: 275.39
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.88,
    y: 305.33,
    width: 75.38,
    height: 60.26,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.608571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.57,
    y: 335.46
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.88,
    y: 365.59,
    width: 75.38,
    height: 62.62,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.655
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.57,
    y: 396.9
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.88,
    y: 428.21,
    width: 75.38,
    height: 64.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.823333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.57,
    y: 460.67999999999995
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.88,
    y: 493.15,
    width: 75.38,
    height: 67.08,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.57,
    y: 526.6899999999999
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.88,
    y: 560.22,
    width: 75.38,
    height: 69.71,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.618333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.57,
    y: 595.075
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 213.88,
    y: 629.93,
    width: 75.38,
    height: 70.07,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.785555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 251.57,
    y: 664.9649999999999
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.26,
    y: 245.45,
    width: 75.75,
    height: 70.47,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.094
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.135,
    y: 280.685
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 365.02,
    y: 245.45,
    width: 81.77,
    height: 70.47,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.83
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.905,
    y: 280.685
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446.79,
    y: 245.45,
    width: 81.85,
    height: 70.47,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.6175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.71500000000003,
    y: 280.685
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528.64,
    y: 245.45,
    width: 85.5,
    height: 70.47,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.067142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 571.39,
    y: 280.685
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 614.14,
    y: 245.45,
    width: 85.86,
    height: 70.47,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.80875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 657.0699999999999,
    y: 280.685
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.26,
    y: 315.92,
    width: 106.2,
    height: 82.78,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.36,
    y: 357.31
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.26,
    y: 398.7,
    width: 106.2,
    height: 89.28,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.36,
    y: 443.34
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.26,
    y: 487.98,
    width: 106.2,
    height: 101.75,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.4375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.36,
    y: 538.855
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.26,
    y: 589.73,
    width: 106.2,
    height: 110.27,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.36,
    y: 644.865
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.46,
    y: 315.92,
    width: 130.36,
    height: 92.45,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.55625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 460.64,
    y: 362.14500000000004
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 525.82,
    y: 315.92,
    width: 174.18,
    height: 92.45,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.9100000000001,
    y: 362.14500000000004
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.46,
    y: 408.37,
    width: 74.89,
    height: 291.63,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.698571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.905,
    y: 554.185
  }, "\n        De_Kalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.35,
    y: 408.37,
    width: 229.65,
    height: 291.63,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 38.275
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.1750000000001,
    y: 554.185
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1944);
export default __webpack_public_path__ + "static/media/1944.22196dffb9ec0c0de1815baf394d9ade.svg";
export { ForwardRef as ReactComponent };